module.exports = __webpack_public_path__ + "img/full2-min.74dca364.png";